import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class SettingsProvider {

  static api_url = environment.apiUrl;



  private static endpoints = {
    home: 'api/check-location',
    register: 'api-auth/register',
    registerConfirm: 'api/register-confirm/',
    auth: 'api-auth/authenticate',
    logout: 'api/auth-logout',
    verifyCode: 'api/verify-code/',
    findEvent: 'api/event/',
    getEventPictures: 'api/event-pictures/',
    findPicture: 'api/picture/'
  };



  constructor() {}

  static authRegister(): string{
    return this.api_url + this.endpoints.register;
  }

  static authLogin(): string{
    return this.api_url + this.endpoints.auth;
  }

  static authLogout(): string{
    return this.api_url + this.endpoints.logout;
  }

  static getUrl(url:string): string{
    // return this.api_url + 'api/' + url;
    return this.api_url + url;
  }

  static getUrlOnly(): string{
    // return this.api_url + 'api/' + url;
    return this.api_url;
  }

  static getCustomUrl(url:string): string{
    return url;
  }

}
